import type { JSX } from '@builder.io/qwik';
import { component$, useContextProvider, Slot } from '@builder.io/qwik';
import AnalyticsContainer from '~/components/Shared/Analytics/AnalyticsContainer';
import { cva } from 'class-variance-authority';
import { CardContext } from '~/contexts/CardContext';
import type { CarouselBlockInterface } from '~/types/AppData/PageBuilder/CarouselBlockInterface';
import { getOneIndexing } from '~/utilities/getOneIndexing';
import { getCSSChildImageAspectRatio } from '~/utilities/getCSS';

const CardClasses = cva('flex gap-4 max-w-[1060px] shrink-0', {
  variants: {
    imageAspectRatio: getCSSChildImageAspectRatio(),
    moreThanFour: {
      true: '[&_article]:flex-[0_0_220px] w-full',
    },
  },
});

export default component$<
  CarouselBlockInterface['props'] & { index: number; items: any[] }
>(({ card, columns, index, items }): JSX.Element => {
  useContextProvider(CardContext, {
    ...card,
    rows: columns,
  });

  const componentName = `Carousel-${getOneIndexing(index)}`;

  return (
    <div class='flex relative overflow-x-auto scrollbar-none'>
      <AnalyticsContainer
        component_name={componentName}
        component_type='Carousel'
        amount_of_articles={items.length}
        component_placement={getOneIndexing(index)}
      >
        <div
          class={CardClasses({
            moreThanFour: columns > 4,
            imageAspectRatio: card.imageAspectRatio,
          })}
        >
          <Slot />
        </div>
      </AnalyticsContainer>
    </div>
  );
});
